import { createAction, props } from '@ngrx/store';
import { BusinessUser } from '@shared';

export const loadBusinessUser = createAction('[Business User] Load Business User');
export const loadBusinessUserSuccess = createAction(
  '[Business User] Load businessUser Success',
  props<{ businessUser: BusinessUser }>(),
);
